// extracted by mini-css-extract-plugin
export default {"content":"sna-z","title":"tna-z","subTitle":"una-z","banner":"vna-z","productCardOverride":"wna-z"};